import type { MenuItem } from '../types/global'

import { KNOWN_FEATURES } from './features'
import { ROUTES } from './routes'
const SIDEBAR_ITEMS = [
  {
    path: ROUTES.OVERVIEW,
    icon: 'Home',
  },
  {
    path: ROUTES.DASHBOARDS,
    icon: 'Speed',
    // todo: Combine logic for enabling/disabling this menu item along with the feature flag check in Sidebar.tsx
    // featureFlag: KNOWN_FEATURES.REPORT_ENGINE,
  },
  {
    path: ROUTES.INSIGHTS,
    icon: 'Sparkles',
    featureFlag: KNOWN_FEATURES.INSIGHTS_MENU,
  },
  {
    icon: 'BrandAwareness',
    featureFlag: KNOWN_FEATURES.CAMPAIGNS_MENU,
    name: 'Publish',
    defaultFlagValue: false,
    children: [
      {
        path: ROUTES.CAMPAIGNS,
        featureFlag: KNOWN_FEATURES.CAMPAIGNS_MENU,
        name: 'Campaigns',
        matchPrefix: true,
      },
      {
        path: ROUTES.ORGANIC_POSTS,
        featureFlag: KNOWN_FEATURES.POSTS_MENU,
        name: 'Posts',
        defaultFlagValue: false,
        matchPrefix: true,
      },
      {
        path: ROUTES.MEDIA_LIBRARY,
        featureFlag: KNOWN_FEATURES.CAMPAIGNS_MENU,
      },
    ],
  },
  {
    path: ROUTES.ACTIVITIES,
    icon: 'Inventory',
    featureFlag: KNOWN_FEATURES.ACTIVITY_CENTER_MENU,
  },
  // {
  //   path: ROUTES.MESSAGES,
  //   icon: 'Chat',
  //   disabled: true,
  // },
  {
    path: ROUTES.MARKETPLACE,
    icon: 'Wand',
    featureFlag: KNOWN_FEATURES.MARKETPLACE_MENU,
  },
  {
    path: ROUTES.CONNECTIONS,
    icon: 'Cable',
    featureFlag: KNOWN_FEATURES.CONNECTIONS_MENU,
  },
  {
    path: ROUTES.DATA_EXPLORER,
    icon: 'ManageSearch',
    name: 'Data Explorer',
    featureFlag: KNOWN_FEATURES.DATA_EXPLORER_MENU,
    defaultFlagValue: false,
  },
  {
    type: 'divider',
  },
  {
    path: ROUTES.BOOK_A_MEETING,
    icon: 'EventUpcoming',
    // todo: Combine logic for enabling/disabling this menu item along with the feature flag check in Sidebar.tsx
    featureFlag: KNOWN_FEATURES.BOOK_A_MEETING_MENU,
  },
  {
    path: ROUTES.KNOWLEDGE_HUB,
    icon: 'Faq',
    featureFlag: KNOWN_FEATURES.KNOWLEDGE_HUB_MENU,
  },
] as MenuItem[]

export {
  SIDEBAR_ITEMS,
}
